<template>
  <div>
    <promo-code-form />
  </div>
</template>

<script>
import PromoCodeForm from '../components/PromoCodeForm.vue'

export default {
  components: {
    PromoCodeForm,
  },
}
</script>

<style>

</style>
